import { z } from "zod"

const shipFromTransitTimeRowSchema = z.object({
  shipFromWarehouseId: z.string().min(1, "Ship From location is required"),
  estimatedTransitDays: z
    .number({ invalid_type_error: "Transit days must be a number" })
    .positive("Transit days must be a positive number")
    .int("Transit days must be a whole number")
    .nullish(),
  isPreferred: z.boolean().nullish(),
})

export const shipFromTransitTimeSchema = z.object({
  rows: z.array(shipFromTransitTimeRowSchema).superRefine((rows, ctx) => {
    const seen = new Set<string>()

    rows.forEach((row, index) => {
      const warehouseId = row.shipFromWarehouseId
      if (warehouseId && seen.has(warehouseId)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "This warehouse is already selected",
          path: [index, "shipFromWarehouseId"],
        })
      } else if (warehouseId) {
        seen.add(warehouseId)
      }
    })
  }),
})

export type ShipFromTransitTimeFormValues = z.infer<typeof shipFromTransitTimeSchema>
